import type {User} from "@sentry/react";

import awsExports from '../../aws-exports';

export class SentryAsync {
    sentryCaptureMessage: ((message: any) => void) = () => {};
    sentrySetUser: ((user: User| null) => void) = () => {};
    init = async () => {
        if (import.meta.env.VITE_SENTRY_DSN) {
            const {setUser, captureMessage, BrowserTracing, init, Replay} = await import('@sentry/react');
            this.sentryCaptureMessage = captureMessage;
            this.sentrySetUser = setUser;
            init({
                dsn: import.meta.env.VITE_SENTRY_DSN,
                integrations: [
                    new BrowserTracing({
                        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
                        tracePropagationTargets: ["dev.logycore.com:5173/", "http://localhost:3000/", "https:logycore.com/api/", "https://stage.logycore.com/"],
                    }),
                    new Replay({
                        networkDetailAllowUrls: [awsExports.aws_appsync_graphqlEndpoint],
                    }),
                ],
                environment: import.meta.env.VITE_APP_ENV,
                // Performance Monitoring
                tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
                // Session Replay
                replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
                replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
            });
        }
    }

    captureMessage = (message: any) => {
        this.sentryCaptureMessage(message);
    }

    setSentryUser = (user: User | null) => {
        this.sentrySetUser(user);
    }
}
